module.exports = __webpack_public_path__ + "iransans.7de08f4ddcaef1edc544.ttf";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Yahoo/Server API/ServerAPI/AdminAngular/src/assets/fonts/iransans.ttf
// module id = ../../../../../src/assets/fonts/iransans.ttf
// module chunks = styles